import React, { useContext, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import useStyles from "./TrackingClasses";
import moment from "moment";
import palette from "../../theme/palette";
import SnackBarComp from "../../components/snackBar";
import { UserTypeContext } from "../../context/userStatus";
import { TrackingContext } from "../../context/userTracking";
import {
  addCategoryJourneyAction,
  addJourneyAction,
  setToturialStepGlobal,
  setUserHeart,
  setUserStreak,
} from "../../store/actions/userTypeAction";
import { trackingService } from "../../services/tracking";
import {
  setDayCompleteMessage,
  setTrackingState,
} from "../../store/actions/trackerAction";
import AddTrackingEventModal from "../tracker/addTrackingEventModal";
import { Typography } from "@mui/material";
import { TRACKING_CONST } from "./constants";
import { isFirefox } from "../../utils/staticDataJson";
import HTMLTooltip from "../../components/HTMLTooltip";
import { pxToRem } from "../../theme/typography";
import { TUTORIAL_STEPS } from "../TutorialsFlow/tutorialsSteps";
const IconPersonalOutcome = ({
  item: catItem,
  category = {} as any,
  style = {},
  date,
  isExpand,
  calendar,
  journyList,
  setOutcomeId,
  outcomeId,
  callservice,
  isLast = false,
  restricted = false,
  className = "",
  showHighlight = false
}) => {
  const classes = useStyles();
  const textareaRef = useRef<HTMLTextAreaElement>();
  const { state: outcomeState, dispatch: UserTypeDispatch } =
    useContext(UserTypeContext);
  const { state: ITrackerState, dispatch: trackingDispatch } =
    useContext(TrackingContext);
  const [item, setItem] = useState<any>();

  const formatedDate = moment(date).format("MM-DD-YYYY");
  const clickCondition = moment(date).isBetween(
    moment().subtract(8, "year"),
    moment().add(1, 'day').startOf('day')
  );

  useEffect(() => {
    if (isLast && ITrackerState.showLoader) {
      trackingDispatch(
        setTrackingState({
          showLoader: false,
          isLastAlreadyLoaded: true,
        })
      );
    }
  }, [isLast, ITrackerState.showLoader]);
  const [openTrackingEventModal, setOpenTrackingEventModal] = useState(false);
  const [displayBorder, setDisplayBorder] = useState(false);
  const [outcomeIndex, setOutcomeIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [optionIndex, setOptionIndex] = useState<any>("");
  const [showInput, setShowInput] = useState(false);
  const [showNotesInput, setShowNotesInput] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputNotesValue, setNotesInputValue] = useState<any>("");
  const [showSnakbar, setShowSnakbar] = useState(false);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const { outcomesResponses = [] } = catItem;
  const heightObj = TRACKING_CONST.EXPAND_HEIGHT;
  React.useLayoutEffect(() => {
    if (!textareaRef.current) return;
    if (textareaRef.current) {
      // Reset height - important to shrink on delete
      textareaRef.current.style.height = "inherit";
      // Set height
      textareaRef.current.style.height = `${Math.max(
        textareaRef.current.scrollHeight,
        32
      )}px`;
    }
  }, [showNotesInput, inputNotesValue]);
  React.useLayoutEffect(() => {
    if (!textareaRef.current) return;
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(
        textareaRef.current.value.length,
        textareaRef.current.value.length
      );
    }
  }, [showNotesInput]);
  const found =
    outcomesResponses && outcomesResponses.length > 0
      ? outcomesResponses.find((journey) => journey?.date === formatedDate)
      : undefined;
  let nearValue = undefined;
  const nearestValueOutcome = (val, influenceItem) => {
    let arr = [];
    if (
      influenceItem.outcomeId &&
      influenceItem.options.length &&
      influenceItem.options[val - 1]
    ) {
      return influenceItem.options[val - 1].colorCode;
    }
    if (influenceItem?.options && influenceItem?.options.length) {
      arr = [...influenceItem?.options].map((it) => it.score);
    }
    const returnVal =
      arr.reduce(
        (p, n) => (Math.abs(p) > Math.abs(n - val) ? n - val : p),
        Infinity
      ) + val;
    if (influenceItem?.options && influenceItem?.options.length) {
      const foundIndexOfValue = influenceItem?.options.findIndex(
        (it) => it.score === returnVal
      );
      if (foundIndexOfValue > -1) {
        return influenceItem?.options[foundIndexOfValue]?.colorCode;
      }
    }
    return false;
  };
  if (found) {
    nearValue = nearestValueOutcome(found?.index, catItem);
    if (found?.type === "TYPE2") {
      nearValue = null;
    }
    if (Number(found?.score) === 0) {
      nearValue = "#C7C7C7";
    }
  }
  const renderToNextInput = (e, categoryId, idx) => {
    console.log("e, categoryId, idx", e, categoryId, idx);
    if (outcomeState.tutorialVisible) {
      return
    }
    if (outcomeState.isPersonal) {
      if (catItem.categoryName !== "Other") {
        const foundCategory = journyList.find(
          (it) => it.categoryId === categoryId
        );
        if (
          foundCategory &&
          foundCategory.alls &&
          foundCategory.alls.length
        ) {
          const findIndexOfEl = foundCategory.alls.findIndex(
            (it) => it._id === idx
          );
          if (findIndexOfEl > -1) {
            // // down arrow handle
            if (
              (e.key === "Enter" || Number(e.keyCode) === 40) &&
              foundCategory.alls[findIndexOfEl + 1] &&
              foundCategory.alls[findIndexOfEl + 1]._id
            ) {
              console.log(
                "foundCategory.alls[findIndexOfEl + 1].skipMetric",
                foundCategory.alls[findIndexOfEl + 1].skipMetric
              );
              if (foundCategory.alls[findIndexOfEl + 1].skipMetric) {
                renderToNextInput(e, categoryId, foundCategory.alls[findIndexOfEl + 1]._id);
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + foundCategory.alls[findIndexOfEl + 1]._id
                );
                console.log("foundElement", foundElement);
                if (foundElement) {
                  foundElement.click();
                }
              }
            } else if (e.key === "Enter" || Number(e.keyCode) === 40) {
              const foundCategoryIndex = journyList.findIndex(
                (it) => it.categoryId === categoryId
              );
              if (foundCategoryIndex > -1) {
                if (journyList[foundCategoryIndex + 1].name === "Other") {
                  if (
                    journyList[foundCategoryIndex + 1].outcomes &&
                    journyList[foundCategoryIndex + 1].outcomes.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].outcomes[0]
                        .skipMetric
                    ) {
                      renderToNextInput(e, categoryId,
                        journyList[foundCategoryIndex + 1].outcomes[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].outcomes[0]._id
                      );
                      if (foundElement) {
                        foundElement.click();
                      }
                    }
                  } else if (
                    journyList[foundCategoryIndex + 1].influences &&
                    journyList[foundCategoryIndex + 1].influences.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].influences[0]
                        .skipMetric
                    ) {
                      renderToNextInput(e, categoryId,
                        journyList[foundCategoryIndex + 1].influences[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].influences[0]._id
                      );
                      if (foundElement) {
                        foundElement.click();
                      }
                    }
                  }
                } else {
                  if (
                    journyList[foundCategoryIndex + 1] &&
                    journyList[foundCategoryIndex + 1].alls &&
                    journyList[foundCategoryIndex + 1].alls.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].alls[0].skipMetric
                    ) {
                      renderToNextInput(e, categoryId,
                        journyList[foundCategoryIndex + 1].alls[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].alls[0]._id
                      );
                      if (foundElement) {
                        foundElement.click();
                      }
                    }
                  }
                }
              }
            }
            // // up arrow key
            if (
              Number(e.keyCode) === 38 &&
              foundCategory.alls[findIndexOfEl - 1] &&
              foundCategory.alls[findIndexOfEl - 1]._id
            ) {
              if (foundCategory.alls[findIndexOfEl - 1].skipMetric) {
                renderToNextInput(e, categoryId, foundCategory.alls[findIndexOfEl - 1]._id);
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + foundCategory.alls[findIndexOfEl - 1]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            }
            //right side arrow keys
            if (Number(e.keyCode) === 39) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .add(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + idx);
              console.log("foundElement", foundElement);
              if (foundElement) {
                foundElement.click();
              }
            }
            //left side arrow keys
            if (Number(e.keyCode) === 37) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .subtract(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + idx);
              if (foundElement) {
                foundElement.click();
              }
            }
          }
        }
      } else {
        const foundOther = (journyList || []).findIndex(
          (it) => it.name === "Other"
        );
        if (foundOther > -1) {
          const outcomeFound = journyList[foundOther].outcomes.findIndex(
            (it) => it._id === idx
          );
          if (outcomeFound > -1) {
            // // down arrow handle
            if (
              (e.key === "Enter" || Number(e.keyCode) === 40) &&
              journyList[foundOther].outcomes[outcomeFound + 1] &&
              journyList[foundOther].outcomes[outcomeFound + 1]._id
            ) {
              if (
                journyList[foundOther].outcomes[outcomeFound + 1].skipMetric
              ) {
                renderToNextInput(e, categoryId,
                  journyList[foundOther].outcomes[outcomeFound + 1]._id
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date +
                  "_" +
                  journyList[foundOther].outcomes[outcomeFound + 1]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            } else if (e.key === "Enter" || Number(e.keyCode) === 40) {
              if (journyList[foundOther].influences[0].skipMetric) {
                renderToNextInput(e, categoryId, journyList[foundOther].influences[0]._id);
              } else {
                const foundZeroInfluence =
                  journyList[foundOther].influences[0]?._id;
                if (foundZeroInfluence) {
                  const date = moment(formatedDate, "mm-DD-yyyy").format(
                    "mm-DD-yyyy"
                  );
                  const foundElement = document.getElementById(
                    date + "_" + journyList[foundOther].influences[0]._id
                  );
                  if (foundElement) {
                    foundElement.click();
                  }
                }
              }
            }
            // // up arrow key
            if (
              Number(e.keyCode) === 38 &&
              journyList[foundOther].outcomes[outcomeFound - 1] &&
              journyList[foundOther].outcomes[outcomeFound - 1]._id
            ) {
              if (
                journyList[foundOther].outcomes[outcomeFound - 1].skipMetric
              ) {
                renderToNextInput(e, categoryId,
                  journyList[foundOther].outcomes[outcomeFound - 1]._id
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date +
                  "_" +
                  journyList[foundOther].outcomes[outcomeFound - 1]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            } else if (Number(e.keyCode) === 38) {
              const foundOther = (journyList || []).findIndex(
                (it) => it.name === "Other"
              );
              if (foundOther > -1) {
                if (
                  journyList[foundOther - 1] &&
                  journyList[foundOther - 1].alls &&
                  journyList[foundOther - 1].alls.length
                ) {
                  if (
                    journyList[foundOther - 1].alls[
                      journyList[foundOther - 1].alls.length - 1
                    ].skipMetric
                  ) {
                    renderToNextInput(e, categoryId,
                      journyList[foundOther - 1].alls[
                        journyList[foundOther - 1].alls.length - 1
                      ]._id
                    );
                  } else {
                    const date = moment(formatedDate, "mm-DD-yyyy").format(
                      "mm-DD-yyyy"
                    );
                    const foundElement = document.getElementById(
                      date +
                      "_" +
                      journyList[foundOther - 1].alls[
                        journyList[foundOther - 1].alls.length - 1
                      ]._id
                    );
                    if (foundElement) {
                      foundElement.click();
                    }
                  }
                }
              }
            }

            //right side arrow keys
            if (Number(e.keyCode) === 39) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .add(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + idx);
              if (foundElement) {
                foundElement.click();
              }
            }
            //left side arrow keys
            if (Number(e.keyCode) === 37) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .subtract(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + idx);
              if (foundElement) {
                foundElement.click();
              }
            }
          } else {
          }
        }
      }
    } else {
      // down arrow key
      if (e.key === "Enter" || Number(e.keyCode) === 40) {
        let nextId = "";
        let nextItem;
        let isLastOutcome = false;
        for (let i = 0; i < outcomeState?.outcomeList?.length; i++) {
          if (outcomeState?.outcomeList[i]._id === idx) {
            if (i === outcomeState?.outcomeList?.length - 1) {
              isLastOutcome = true;
            }
            nextId = outcomeState?.outcomeList[i + 1]?._id;
            nextItem = outcomeState?.outcomeList[i + 1];
          }
        }
        console.log(
          "isLastOutcome",
          nextItem?.skipMetric,
          nextId,
          isLastOutcome
        );
        if (nextItem?.skipMetric && nextId) {
          renderToNextInput(e, categoryId, nextId);
        } else if (nextId) {
          const foundElement = document.getElementById(
            formatedDate + "_" + nextId
          );
          console.log("foundElement", foundElement)
          if (foundElement) {
            foundElement.click();
          }
          setOutcomeId(nextId);
          setItem(nextItem);
          setShowInput(false);
          setInputValue("");
        } else {
          if (isLastOutcome) {
            const filteredWithoutSkipMetric = [
              ...outcomeState?.influenceList,
            ].filter((it) => !it.skipMetric);
            if (
              filteredWithoutSkipMetric &&
              filteredWithoutSkipMetric.length
            ) {
              const foundZeroInfluence = filteredWithoutSkipMetric[0]?._id;
              if (foundZeroInfluence) {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + filteredWithoutSkipMetric[0]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            }
          } else {
            const foundZeroInfluence = outcomeState?.influenceList[0]?._id;
            if (foundZeroInfluence) {
              const date = moment(formatedDate, "mm-DD-yyyy").format(
                "mm-DD-yyyy"
              );
              const foundElement = document.getElementById(
                date + "_" + outcomeState?.influenceList[0]._id
              );
              if (foundElement) {
                foundElement.click();
              }
            }
          }
        }
      }

      // up arrow key
      if (Number(e.keyCode) === 38) {
        let prevId = "";
        let prevItem;
        for (let i = 0; i < outcomeState?.outcomeList?.length; i++) {
          if (outcomeState?.outcomeList[i]._id === idx) {
            prevId = outcomeState?.outcomeList[i - 1]?._id;
            prevItem = outcomeState?.outcomeList[i - 1];
          }
        }
        if (prevItem.skipMetric && prevId) {
          renderToNextInput(e, categoryId, prevId);
        } else if (prevId) {
          const foundElement = document.getElementById(
            formatedDate + "_" + prevId
          );
          if (foundElement) {
            foundElement.click();
          }
          setOutcomeId(prevId);
          setItem(prevItem);
          setShowInput(false);
          setInputValue("");
        }
      }

      //right side arrow keys
      if (Number(e.keyCode) === 39) {
        setOutcomeId(idx);
        setItem([...outcomeState?.outcomeList].find((it) => it._id === idx));
        const date = moment(formatedDate, "mm-DD-yyyy")
          .add(1, "day")
          .format("mm-DD-yyyy");
        const foundElement = document.getElementById(date + "_" + idx);
        if (foundElement) {
          foundElement.click();
        }
      }

      if (Number(e.keyCode) === 37) {
        setOutcomeId(idx);
        setItem([...outcomeState?.outcomeList].find((it) => it._id === idx));
        const date = moment(formatedDate, "mm-DD-yyyy")
          .subtract(1, "day")
          .format("mm-DD-yyyy");
        const foundElement = document.getElementById(date + "_" + idx);
        if (foundElement) {
          foundElement.click();
        }
      }
    }
  };
  const proceedTutorialToNextStep = (step = localStorage.getItem("tutorialStep")) => {
    if (outcomeState.tutorialVisible) {
      const foundStepIndex = TUTORIAL_STEPS.findIndex(it => it.step === Number(`${(Number(step) + 1)}`))
      console.log("foundStepIndex", foundStepIndex, TUTORIAL_STEPS[foundStepIndex].skip);
      if (foundStepIndex > -1) {
        if (TUTORIAL_STEPS[foundStepIndex].skip) {
          proceedTutorialToNextStep(`${Number(step) + 1}`)
        } else {
          localStorage.setItem("tutorialStep", `${(Number(step) + 1)}`)
          UserTypeDispatch(setToturialStepGlobal(Number(`${(Number(step) + 1)}`)))
        }
      } else {
        localStorage.setItem("tutorialStep", `${(Number(step) + 1)}`)
        UserTypeDispatch(setToturialStepGlobal(Number(`${(Number(step) + 1)}`)))
      }
    }
  }
  const trackEve = () => {
    const foundCurrentStep = TUTORIAL_STEPS.findIndex(it => it.step === 9)
    if (foundCurrentStep > -1 && TUTORIAL_STEPS[foundCurrentStep] && TUTORIAL_STEPS[foundCurrentStep].trackEventName) {
      trackingService.signupCompletedBoarding(outcomeState.token, {
        mixpanel_type: TUTORIAL_STEPS[foundCurrentStep].trackEventName
      });
    }
  }
  const handleBlurInput = (id: any, e: any, mouseOut: boolean, categoryId) => {

    if (mouseOut) {
      setShowInput(false);
    }
    if (
      e.key === "Enter" ||
      Number(e.keyCode) === 37 ||
      Number(e.keyCode) === 38 ||
      Number(e.keyCode) === 39 ||
      Number(e.keyCode) === 40 ||
      mouseOut
    ) {
      console.log("showHighlight", showHighlight);

      if (catItem.absenceToggle) {
        if (inputValue) {
          if (parseInt(inputValue) >= 0 && parseInt(inputValue) <= 5) {
            setShowInput(false);
            outcomeCreate();
            if (showHighlight) {
              trackEve()
              proceedTutorialToNextStep()
            } else {
              renderToNextInput(e, categoryId, id);
            }
          } else {
            setShowSnakbar(true);
            setMsgType("error");
            setSnakbarMsg("Please enter value between 0 to 5");
          }
        }
      } else {
        if (inputValue) {
          if (parseInt(inputValue) > 0 && parseInt(inputValue) <= 5) {
            setShowInput(false);
            outcomeCreate();
            if (showHighlight) {
              trackEve()
              proceedTutorialToNextStep()
            } else {
              renderToNextInput(e, categoryId, id);
            }
          } else {
            setShowSnakbar(true);
            setMsgType("error");
            setSnakbarMsg("Please enter value between 1 to 5");
          }
        }
      }

    }
  };
  const handleBlurInputArea = (type, e: any, mouseOut, categoryId, id) => {
    if (mouseOut) {
      setShowNotesInput(false);
    }
    if (
      Number(e.keyCode) === 37 ||
      Number(e.keyCode) === 38 ||
      Number(e.keyCode) === 39 ||
      Number(e.keyCode) === 40 ||
      mouseOut
    ) {
      outcomeCreate(true);
    }
  };
  const outcomeCreate = (isHasNotes = false) => {
    const outcomeCreateData: any = {
      date: formatedDate,
      outcomeId: catItem?.outcomeId,
      note: [inputNotesValue],
    };
    // Number("") is 0 — do not treat empty input as a valid metric (avoids NaN index and bad options[] access).
    const inputStr =
      inputValue !== "" && inputValue != null
        ? String(inputValue).trim()
        : "";
    if (inputStr !== "") {
      const n = parseInt(inputStr, 10);
      if (Number.isFinite(n) && n >= 0) {
        outcomeCreateData.index = n;
        outcomeCreateData.answerId =
          n === 0 ? null : catItem?.options[n - 1]?.answerId;
        outcomeCreateData.score =
          n === 0 ? 0 : catItem?.options[n - 1]?.score;
      }
    } else if (isHasNotes && found?.type === "TYPE2") {
      outcomeCreateData.index = found.index;
      outcomeCreateData.answerId = found.answerId;
      outcomeCreateData.score = found.score;
    }
    outcomeCreateData.note = outcomeCreateData.note.filter((it) => it);
    let oldData: any = {};
    if (!isHasNotes) {
      if (!outcomeState?.isPersonal) {
        const foundOutcome = (outcomeState?.outcomeList || []).find(
          (it) => it.outcomeId === outcomeCreateData.outcomeId
        );
        if (foundOutcome) {
          const journyList = { ...(outcomeState?.journeyList || {}) } as any;
          const foundDateItemIcon = journyList.outcome_data.findIndex(
            (it) =>
              it.outcomeId === outcomeCreateData.outcomeId &&
              it?.date === outcomeCreateData.date
          );
          if (foundDateItemIcon > -1) {
            oldData = { ...journyList.outcome_data[foundDateItemIcon] };
          }
        }
      } else {
        const journeyCategoryList = [...(journyList || [])];
        const foundOutcome = (journeyCategoryList || []).findIndex(
          (it) =>
            it.outcomeIds && it.outcomeIds.includes(outcomeCreateData.outcomeId)
        );
        if (foundOutcome > -1) {
          if (
            journeyCategoryList[foundOutcome].alls &&
            journeyCategoryList[foundOutcome].alls.length
          ) {
            const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(
              (it) => it.outcomeId === outcomeCreateData.outcomeId
            );
            if (foundIndex > -1) {
              if (
                journeyCategoryList[foundOutcome].alls[foundIndex]
                  .outcomesResponses &&
                journeyCategoryList[foundOutcome].alls[foundIndex]
                  .outcomesResponses.length
              ) {
                const foundDateValue = journeyCategoryList[foundOutcome].alls[
                  foundIndex
                ].outcomesResponses.findIndex(
                  (it) => it.date === outcomeCreateData.date
                );
                if (foundDateValue > -1) {
                  oldData = {
                    ...journeyCategoryList[foundOutcome].alls[foundIndex]
                      .outcomesResponses[foundDateValue],
                  };
                }
              }
            }
          }
        } else {
          const foundOther = (journeyCategoryList || []).findIndex(
            (it) => it.name === "Other"
          );
          if (foundOther > -1) {
            const outcomeFound = journeyCategoryList[
              foundOther
            ].outcomes.findIndex(
              (it) => it.outcomeId === outcomeCreateData.outcomeId
            );
            if (outcomeFound > -1) {
              if (
                journeyCategoryList[foundOther].outcomes[outcomeFound]
                  .outcomesResponses &&
                journeyCategoryList[foundOther].outcomes[outcomeFound]
                  .outcomesResponses.length
              ) {
                const foundDateValue = journeyCategoryList[foundOther].outcomes[
                  outcomeFound
                ].outcomesResponses.findIndex(
                  (it) => it.date === outcomeCreateData.date
                );
                if (foundDateValue > -1) {
                  oldData = {
                    ...journeyCategoryList[foundOther].outcomes[outcomeFound]
                      .outcomesResponses[foundDateValue],
                  };
                }
              }
            }
          }
        }
      }
      if (oldData?.note && oldData?.note.length) {
        outcomeCreateData.note = oldData?.note || [];
      }
    }
    const foundOutcomeDef = (outcomeState?.outcomeList || []).find(
      (it) => it.outcomeId === outcomeCreateData.outcomeId
    );
    console.log("foundOutcomeDef", foundOutcomeDef);

    if (foundOutcomeDef) {
      const journyList = { ...(outcomeState?.journeyList || {}) } as any;
      const foundDateItemIcon = journyList.outcome_data.findIndex(
        (it) =>
          it.outcomeId === outcomeCreateData.outcomeId &&
          it?.date === outcomeCreateData.date
      );
      console.log("journyList.outcome_data[foundDateItemIcon]", journyList.outcome_data[foundDateItemIcon]);

      if (foundDateItemIcon > -1) {
        // Only use previous row data when user didn't submit a value (null/undefined). Don't overwrite when user explicitly chose 0.
        if (outcomeCreateData.index == null && outcomeCreateData.score == null) {
          outcomeCreateData.answerId = journyList.outcome_data[foundDateItemIcon].answerId;
          outcomeCreateData.index = journyList.outcome_data[foundDateItemIcon].index;
          outcomeCreateData.score = journyList.outcome_data[foundDateItemIcon].score;
        }
        journyList.outcome_data[foundDateItemIcon] = {
          ...foundOutcomeDef,
          ...outcomeCreateData,
        };
      } else {
        journyList.outcome_data.push({
          ...foundOutcomeDef,
          ...outcomeCreateData,
        } as any);
      }

      UserTypeDispatch(addJourneyAction(journyList as any));
    }
    const journeyCategoryList = [...(journyList || [])];
    const foundOutcome = (journeyCategoryList || []).findIndex(
      (it) =>
        it.outcomeIds && it.outcomeIds.includes(outcomeCreateData.outcomeId)
    );
    if (foundOutcome > -1) {
      if (
        journeyCategoryList[foundOutcome].alls &&
        journeyCategoryList[foundOutcome].alls.length
      ) {
        const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(
          (it) => it.outcomeId === outcomeCreateData.outcomeId
        );
        if (foundIndex > -1) {
          if (
            journeyCategoryList[foundOutcome].alls[foundIndex]
              .outcomesResponses &&
            journeyCategoryList[foundOutcome].alls[foundIndex].outcomesResponses
              .length
          ) {
            const foundDateValue = journeyCategoryList[foundOutcome].alls[
              foundIndex
            ].outcomesResponses.findIndex(
              (it) => it.date === outcomeCreateData.date
            );
            if (foundDateValue > -1) {
              journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].outcomesResponses[foundDateValue] = {
                ...outcomeCreateData,
              };
            } else {
              journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].outcomesResponses.push(outcomeCreateData);
            }
          } else {
            journeyCategoryList[foundOutcome].alls[
              foundIndex
            ].outcomesResponses = [outcomeCreateData];
          }
          UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
        }
      }
    } else {
      const foundOther = (journeyCategoryList || []).findIndex(
        (it) => it.name === "Other"
      );
      if (foundOther > -1) {
        const outcomeFound = journeyCategoryList[foundOther].outcomes.findIndex(
          (it) => it.outcomeId === outcomeCreateData.outcomeId
        );
        if (outcomeFound > -1) {
          if (
            journeyCategoryList[foundOther].outcomes[outcomeFound]
              .outcomesResponses &&
            journeyCategoryList[foundOther].outcomes[outcomeFound]
              .outcomesResponses.length
          ) {
            const foundDateValue = journeyCategoryList[foundOther].outcomes[
              outcomeFound
            ].outcomesResponses.findIndex(
              (it) => it.date === outcomeCreateData.date
            );
            if (foundDateValue > -1) {
              journeyCategoryList[foundOther].outcomes[
                outcomeFound
              ].outcomesResponses[foundDateValue] = {
                ...outcomeCreateData,
              };
            } else {
              journeyCategoryList[foundOther].outcomes[
                outcomeFound
              ].outcomesResponses.push(outcomeCreateData);
            }
          } else {
            journeyCategoryList[foundOther].outcomes[
              outcomeFound
            ].outcomesResponses = [outcomeCreateData];
          }
          UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
        }
      }
    }

    trackingService
      .outcomeCreate(outcomeState.token, outcomeCreateData)
      .then((data) => {
        setInputValue("")
        if (
          data.showMessage &&
          formatedDate === moment().format("MM-DD-YYYY")
        ) {
          trackingDispatch(
            setDayCompleteMessage({
              open: data.showMessage,
              message: data.message,
            })
          );
        }
        if (data.dataStreak) {
          UserTypeDispatch(setUserStreak())
        }
        if (data.heartIncreaseFlag) {
          UserTypeDispatch(setUserHeart())
        }
      })
      .catch((error) => {
        setShowSnakbar(true);
        setSnakbarMsg(
          error?.response?.data?.message
            ? error?.response?.data?.message
            : error?.message
        );
        setMsgType("error");
      });
  };


  const renderInput = <div
    style={{
      display: "flex",
      width: "176px",
      // height: length,
      padding: "12px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
      alignSelf: "stretch",
      borderRadius: "12px",
      border: "1px solid #F3F3F3",
      background: "var(--white-background)",
      flexBasis: "100%",
      margin: "13px 8px 0px 0",
      overflowY: "auto",
      wordWrap: "break-word",
      ...heightObj,
    }}
    onClick={(outcomeState.tutorialVisible && (outcomeState.tutorialStep !== 9)) || restricted ? () => { } : () => {
      if (clickCondition && !found) {
        const i = outcomeState.outcomeList.findIndex(
          (outcome) => outcome._id === catItem._id
        );
        setOutcomeIndex(i);
        setShowInput(false);
        setOpenTrackingEventModal(true);
        setDisplayBorder(true);
        setOutcomeId(catItem._id);
        setItem(catItem);
        setSelectedOption(parseInt(optionIndex + 1));
      } else if (clickCondition && !showNotesInput) {
        setShowInput(false);
        setInputValue(found?.index);
        setShowNotesInput(true);
        setDisplayBorder(true);
        setOutcomeId(catItem._id);
        setNotesInputValue(found?.note && found?.note[0]);
        setItem(catItem);
        setSelectedOption(parseInt(optionIndex + 1));
      }
      // }
    }}
    onDoubleClick={outcomeState.tutorialVisible ? () => { } : restricted ? () => { } : (e) => {
      e.stopPropagation();
      if (clickCondition) {
        const i = outcomeState.outcomeList.findIndex(
          (outcome) => outcome._id === catItem._id
        );
        setOutcomeIndex(i);
        setShowNotesInput(false);
        setShowInput(false);
        setOpenTrackingEventModal(true);
        setDisplayBorder(true);
        setOutcomeId(catItem._id);
        setItem(catItem);
        setSelectedOption(parseInt(optionIndex + 1));
      }
    }}
  >
    {showNotesInput ? (
      <textarea
        name={catItem?._id}
        autoFocus
        ref={textareaRef}
        value={inputNotesValue}
        style={{
          width: "100%",
          minHeight: "10px",
          resize: "none",
        }}
        onBlur={() => {
          handleBlurInputArea(
            catItem?.type,
            { key: "kdksjdks", keyCode: "hdj" },
            true,
            outcomeState.isPersonal ? category.categoryId : null,
            catItem._id
          );
        }}
        onChange={(e) => {
          setNotesInputValue(e.target.value);
        }}
        onKeyDown={(e) => {
          handleBlurInputArea(
            catItem?.type,
            e,
            false,
            outcomeState.isPersonal ? category.categoryId : null,
            catItem._id
          );
        }}
      />
    ) : (
      <>
        {found?.note && found?.note[0] ? (
          <Typography
            id={`${catItem?.outcomeId}_${formatedDate}`}
            variant="h5"
            sx={{
              color: palette.common.black,
              marginBottom: "0px !important",
            }}
            component="span"
            title={found?.note}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: found?.note[0].replace(/\n/g, "<br />") || "",
              }}
            ></span>
          </Typography>
        ) : null}
      </>
    )}
  </div>
  return (
    <td
      className={clsx(
        classes.cell,
        classes.borderBottom,
        isExpand ? classes.iconExpand : "",
        className
      )}
      style={{
        position: "relative",
        height: isFirefox ? "100%" : "inherit",
        ...style,
      }}
      key={catItem._id}
    >
      <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={() => {
          setShowSnakbar(false);
        }}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "success"}
      />
      <div
        style={
          isExpand
            ? {
              height: "100%",
            }
            : {
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }
        }
      >
        <div
          className={
            moment(calendar[calendar.length - 1]).format("MM-DD-YYYY") ===
              formatedDate
              ? classes.iconInnerWithoutAfter
              : classes.iconInner
          }
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: isExpand ? "flex-start" : "center",
            flexBasis: "100%",
          }}
          onClick={(e) => {
            if (clickCondition && !restricted) {
              setItem(catItem);
              setOutcomeId(catItem._id);
            }
          }}
        >
          {showInput ? (
            <span
              className={classes.addOutlineIconInput}
              onDoubleClick={outcomeState.tutorialVisible ? () => { } : () => {
                if (clickCondition) {
                  let i = outcomeState.outcomeList.findIndex(
                    (outcome) => outcome._id === catItem?._id
                  );
                  setOutcomeIndex(i);
                  setShowInput(false);
                  setOpenTrackingEventModal(true);
                  setDisplayBorder(true);
                  setOutcomeId(catItem._id);
                  setItem(catItem);
                  setSelectedOption(parseInt(optionIndex + 1));
                }
              }}
            >
              <input
                name={catItem?._id}
                type="text"
                autoFocus
                onBlur={() => {
                  handleBlurInput(
                    item?._id,
                    { key: "kdksjdks", keyCode: "hdj" },
                    true,
                    outcomeState.isPersonal ? category.categoryId : null
                  );
                }}
                onChange={(e) => {
                  setInputValue(e.target.value);
                }}
                onKeyDown={(e) => {
                  handleBlurInput(
                    item?._id,
                    e,
                    false,
                    outcomeState.isPersonal ? category.categoryId : null
                  );
                }}
              />
            </span>
          ) : (
            <span
              className={showHighlight && !found ? classes.addOutlineIconTutorial : classes.addOutlineIcon}
              onDoubleClick={outcomeState.tutorialVisible ? () => { } : () => {
                if (clickCondition && !restricted) {
                  let i = outcomeState.outcomeList.findIndex(
                    (outcome) => outcome._id === catItem?._id
                  );
                  setOutcomeIndex(i);
                  setShowInput(false);
                  setOpenTrackingEventModal(true);
                  setDisplayBorder(true);
                  setOutcomeId(catItem._id);
                  setItem(catItem);
                  setSelectedOption(parseInt(optionIndex + 1));
                }
              }}
            >
              {found ? (
                <HTMLTooltip
                  placement="right"
                  customIcon={<div
                    className="hello"
                    key={catItem._id}
                    id={formatedDate + "_" + catItem._id}
                    onClick={outcomeState.tutorialVisible && (outcomeState.tutorialStep !== 9) ? () => { } : () => {
                      if (clickCondition && !restricted) {
                        setShowInput(true);
                        setDisplayBorder(true);
                        setOutcomeId(catItem._id);
                        setItem(catItem);
                      }
                    }}
                  >
                    <span
                      className={
                        found?.note.length > 0 ? classes.borderOutline : ""
                      }
                      style={
                        found?.note.length > 0
                          ? {
                            padding: "2px",
                            border: `1px solid ${nearValue ? nearValue : found.colorCode
                              }`,
                            borderRadius: "50%",
                          }
                          : {
                            border: `1px solid ${nearValue ? nearValue : found.colorCode
                              }`,
                            backgroundColor: found.colorCode,
                          }
                      }
                    >
                      <span
                        style={{
                          backgroundColor: nearValue
                            ? nearValue
                            : found.colorCode,
                          border: `1px solid ${nearValue ? nearValue : found.colorCode
                            }`,
                          borderRadius: "50%",
                          color: palette.common.white,
                        }}
                      >
                        {found.index}
                      </span>
                    </span>
                  </div>}
                  title={restricted ? "You can’t add entries on expired trial" : null}
                  fontProps={{
                    fontSize: `${pxToRem(12)} !important`,
                  }}
                  sx={{
                    "& .MuiTooltip-tooltip": {
                      maxWidth: "320px",
                      background: "var(--color-border)",
                      border: "1px solid var(--color-border)",
                      "& .MuiTooltip-arrow": {
                        color: "var(--color-border)",
                        "&:before": {
                          border: "1px solid var(--color-border)",
                        }
                      }
                    },
                  }}
                />
              ) : <HTMLTooltip
                placement="right"
                customIcon={
                  <span
                    key={catItem._id}
                    id={formatedDate + "_" + catItem._id}
                    onClick={outcomeState.tutorialVisible && (outcomeState.tutorialStep !== 9) ? () => { } : () => {
                      console.log("clickCondition", clickCondition)
                      if (clickCondition && !restricted) {
                        setShowInput(true);
                        setDisplayBorder(true);
                        setOutcomeId(catItem._id);
                        setItem(catItem);
                      }
                    }}
                  >
                    {showHighlight && !found ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.00118 0.200012C6.45848 0.200012 4.95043 0.657474 3.66773 1.51455C2.38502 2.37162 1.38528 3.58982 0.794915 5.01508C0.204551 6.44035 0.0500855 8.00867 0.35105 9.52172C0.652015 11.0348 1.39489 12.4246 2.48574 13.5154C3.57659 14.6063 4.96642 15.3492 6.47947 15.6501C7.99252 15.9511 9.56084 15.7966 10.9861 15.2063C12.4114 14.6159 13.6296 13.6162 14.4866 12.3335C15.3437 11.0508 15.8012 9.54271 15.8012 8.00001C15.7986 5.93212 14.976 3.94965 13.5138 2.48743C12.0515 1.0252 10.0691 0.202592 8.00118 0.200012ZM11.0012 8.60001H8.60118V11C8.60118 11.1591 8.53796 11.3118 8.42544 11.4243C8.31292 11.5368 8.16031 11.6 8.00118 11.6C7.84205 11.6 7.68943 11.5368 7.57691 11.4243C7.46439 11.3118 7.40118 11.1591 7.40118 11V8.60001H5.00118C4.84205 8.60001 4.68943 8.5368 4.57691 8.42428C4.46439 8.31176 4.40118 8.15914 4.40118 8.00001C4.40118 7.84088 4.46439 7.68827 4.57691 7.57575C4.68943 7.46323 4.84205 7.40001 5.00118 7.40001H7.40118V5.00001C7.40118 4.84088 7.46439 4.68827 7.57691 4.57575C7.68943 4.46323 7.84205 4.40001 8.00118 4.40001C8.16031 4.40001 8.31292 4.46323 8.42544 4.57575C8.53796 4.68827 8.60118 4.84088 8.60118 5.00001V7.40001H11.0012C11.1603 7.40001 11.3129 7.46323 11.4254 7.57575C11.538 7.68827 11.6012 7.84088 11.6012 8.00001C11.6012 8.15914 11.538 8.31176 11.4254 8.42428C11.3129 8.5368 11.1603 8.60001 11.0012 8.60001Z" fill="#FF5555" />
                    </svg>
                      : "+"}
                  </span>
                }
                title={restricted ? "You can’t add entries on expired trial" : null}
                fontProps={{
                  fontSize: `${pxToRem(12)} !important`,
                }}
                sx={{
                  "& .MuiTooltip-tooltip": {
                    maxWidth: "320px",
                    background: "var(--color-border)",
                    border: "1px solid var(--color-border)",
                    "& .MuiTooltip-arrow": {
                      color: "var(--color-border)",
                      "&:before": {
                        border: "1px solid var(--color-border)",
                      }
                    }
                  },
                }}
              />}
            </span>
          )}
        </div>
        {outcomeState?.isExpand ? restricted ? <HTMLTooltip
          placement="right"
          customIcon={renderInput}
          title={"You can’t add entries on expired trial"}
          fontProps={{
            fontSize: `${pxToRem(12)} !important`,
          }}
          sx={{
            "& .MuiTooltip-tooltip": {
              maxWidth: "320px",
              background: "var(--color-border)",
              border: "1px solid var(--color-border)",
              "& .MuiTooltip-arrow": {
                color: "var(--color-border)",
                "&:before": {
                  border: "1px solid var(--color-border)",
                }
              }
            },
          }}
        /> : renderInput : null}
      </div>

      {openTrackingEventModal && (
        <AddTrackingEventModal
          setOpenTrackingEventModal={setOpenTrackingEventModal}
          index={outcomeIndex}
          setOutcomeId={setOutcomeId}
          getBackgroudColor={() => { }}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          setShowInput={setShowInput}
          outcomeId={outcomeId}
          item={catItem}
          setShowSnakbar={setShowSnakbar}
          setSnakbarMsg={setSnakbarMsg}
          setMsgType={setMsgType}
          setOptionIndex={setOptionIndex}
          optionIndex={optionIndex}
          setDisplayBorder={setDisplayBorder}
          displayBorder={displayBorder}
          callService={callservice}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          journeyData={journyList}
          headerDate={formatedDate}
          renderToNextInput={() => {
            setTimeout(() => {
              renderToNextInput(
                {
                  key: "Enter",
                },
                outcomeState.isPersonal ? category.categoryId : null,
                catItem._id
              );
            }, 200);

          }}
        />
      )}
    </td>
  );
};

export default IconPersonalOutcome;
